module.exports = __webpack_public_path__ + "0db26988c420307d6e5dabab147fd24b.glb";